// Controlled creative variation system - three genuinely distinct ad directions.
// The boat is always the hero. The photo is NEVER altered: styles only add
// scrim, overlay, typography, spec chips, logo and CTA on top of the untouched image.
// Price is intentionally de-emphasized (marine dealers rarely advertise price);
// deal wording appears only as an optional badge derived from real inventory data.

export const CREATIVE_STYLES = [
  {
    id: "conservative",
    name: "Clean",
    tagline: "Elegant, full-bleed, editorial minimal",
    layout: "full-clean",
    accent: "#D4AF37",
    headlineFont: "sans",
    headlineCase: "none",
    badge: false,
    logoPos: "tl",
  },
  {
    id: "modern",
    name: "Modern",
    tagline: "Editorial navy panel, spec-forward",
    layout: "panel",
    accent: "#E8C766",
    headlineFont: "sans",
    headlineCase: "none",
    badge: true,
    logoPos: "tl",
  },
  {
    id: "bold",
    name: "Bold",
    tagline: "Stop-the-scroll, oversized, framed",
    layout: "full-bold",
    accent: "#F2CE55",
    headlineFont: "sans",
    headlineCase: "upper",
    badge: true,
    logoPos: "tr",
  },
];

export const styleForIndex = (i) => CREATIVE_STYLES[i] || CREATIVE_STYLES[0];

const ENGINE_WORDS = { 1: "Single", 2: "Twin", 3: "Triple", 4: "Quad", 5: "Quint" };

function engineSummary(boat) {
  const countRaw = String(boat?.engine_count || "").trim();
  const hp = boat?.horsepower;
  let countWord = "";
  const num = parseInt(countRaw.replace("+", ""), 10);
  if (!Number.isNaN(num) && num > 0) countWord = ENGINE_WORDS[num] || `${num}x`;
  else if (/single|twin|triple|quad|quint/i.test(countRaw)) countWord = countRaw.replace(/\b\w/g, (m) => m.toUpperCase());
  const parts = [];
  if (countWord) parts.push(countWord);
  if (hp) parts.push(`${hp} HP`);
  return parts.join(" ");
}

// Real-fact spec chips for a boat (year, category, engine setup). No price, no fabrication.
export function boatSpecChips(boat) {
  if (!boat) return [];
  const chips = [];
  if (boat.year) chips.push(String(boat.year));
  const cat = (boat.category || "").trim();
  if (cat) chips.push(cat);
  const eng = engineSummary(boat);
  if (eng) chips.push(eng);
  return chips.slice(0, 3);
}

// On-brand deal badge from real inventory facts only. Never fabricates an offer.
export function pickBadge(boat, index) {
  const st = CREATIVE_STYLES[index];
  if (!st || !st.badge) return "";
  const status = (boat?.status || "").toLowerCase();
  const promo = boat?.promo_price;
  const orig = boat?.original_price || boat?.price;
  const isReduced = promo && orig && Number(promo) < Number(orig);
  if (isReduced) return "Price Reduced";
  if (status.includes("order")) return "Arriving Soon";
  if (index === 2) return "New Arrival";
  return "In Stock";
}
